import { notification } from "antd";
import { get, isNil, noop } from "lodash";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import { NAME_SPACES } from "shared/locales/constants";
import graphql from "utils/api/graphql";
import { DOCUMENT_KINDS, SCREENS } from "utils/constants";
import View from "./View";

const CreateStatic = () => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS);
  const navigate = useNavigate();
  const [addDocument, { loading }] = useMutation(
    graphql.mutations.CREATE_STATIC_DOCUMENT,
    { onError: noop },
  );

  const cancel = () =>
    navigate(SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.LIST.path, {
      state: { kind: DOCUMENT_KINDS.STATIC },
    });

  const onSubmit = async (data) => {
    const { data: result } = await addDocument({ variables: { data } });
    if (isNil(get(result, "addStaticDocument.id"))) {
      notification.error({ message: t("STATIC.FORM.FAILED") });
      return;
    }
    notification.success({ message: t("STATIC.FORM.SAVED") });
    cancel();
  };

  return <View onSubmit={onSubmit} cancel={cancel} loading={loading} />;
};

export default CreateStatic;
